// extracted by mini-css-extract-plugin
module.exports = {"pt-img":"pt-img-95919d9d17e0408858ecd676e5c831ee"};